import { Link, useParams } from "react-router-dom";
import { CommandBar } from "../Shell";
import { Icon } from "../icons";
import { STATUS_LABEL, areaHref, findModule, moduleHref } from "../suite";
import { BcLink } from "../SuiteGrid";
import { ANCHORS } from "../models";
import { AnchorCard } from "../RecordGroups";

export function ModulePage() {
  const { id = "" } = useParams();
  const found = findModule(id);
  if (!found) return <div className="page"><div className="card empty">Unknown app. <Link to="/">Go home</Link></div></div>;
  const { domain, module: m } = found;
  const siblings = domain.modules.filter((x) => x.id !== m.id);
  const anchor = Object.values(ANCHORS).flat().find((a) => a.node.app === m.id);

  return (
    <>
      <CommandBar status={`${domain.name} · ${STATUS_LABEL[m.status]}`}>
        <Link className="cmd" to={areaHref(domain)}>← {domain.name}</Link>
        <Link className="cmd" to="/ontology">See it in the ontology</Link>
      </CommandBar>
      <div className="page">
        <div className="page-title">
          <nav className="crumbs" aria-label="Breadcrumb" style={{ flexBasis: "100%", margin: 0 }}><Link to="/">Home</Link><span>/</span><Link to={areaHref(domain)}>{domain.name}</Link><span>/</span><span>{m.name}</span></nav>
          <h1 className="serif" style={{ fontSize: 30 }}>{m.name}</h1>
          <span className={`status ${m.status === "live" ? "info" : m.status === "bc" ? "" : "warn"}`}>{STATUS_LABEL[m.status]}</span>
        </div>
        {anchor && (
          <section className="area-sec">
            <div className="sec-h"><h2>Each {m.name.replace(/s$/, "").toLowerCase()} shows</h2></div>
            <AnchorCard a={anchor} compact />
          </section>
        )}
        <div className="grid cols-main">
          <section className="card">
            <div className="card-head"><h2>{m.status === "bc" ? "Pages" : "What it will do"}</h2></div>
            <div className="card-body">
              <p style={{ marginTop: 0, fontSize: 16, lineHeight: "24px" }}>{m.summary}</p>
              {m.pages?.length ? (
                <ul className="app-pages" style={{ borderTop: 0, paddingTop: 0, marginBottom: 12 }}>
                  {m.pages.map((p) => <li key={p.name}>{p.bc
                    ? <BcLink p={{ name: p.name, page: p.bc }}><span className="tag bc">BC</span>{p.name}<Icon name="ext" size={11} /></BcLink>
                    : <Link to={p.to ?? moduleHref(m)} className={p.to ? "" : "planned"}><span className="tag cm" />{p.name}{!p.to && <span className="muted" style={{ fontSize: 11 }}>planned</span>}</Link>}</li>)}
                </ul>
              ) : null}
              {m.does?.length ? <ul style={{ paddingLeft: 20, margin: "0 0 12px" }}>{m.does.map((d) => <li key={d} style={{ marginBottom: 6 }}>{d}</li>)}</ul> : null}
              {m.status !== "bc" && <div className="msg info" style={{ marginBottom: 0 }}>
                {m.status === "future" ? "Planned for a later release." : `Planned for ${STATUS_LABEL[m.status]}.`} It will use the same records, workflow, audit trail and AI tools as Issues and CAPA.
              </div>}
            </div>
          </section>
          <div className="stack">
            {m.bc?.length ? (
              <section className="card">
                <div className="card-head"><h2>Business Central records</h2></div>
                <div className="card-body" style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                  {m.bc.map((b) => <span key={b} className="chip-bc"><span className="k">BC</span><span className="v" style={{ fontFamily: "var(--font)" }}>{b}</span></span>)}
                </div>
              </section>
            ) : null}
            <section className="card">
              <div className="card-head"><h2>Also in {domain.name}</h2></div>
              <div className="card-body" style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                {siblings.map((s) => (
                  <Link key={s.id} to={moduleHref(s)} style={{ display: "flex", alignItems: "center", gap: 10, color: "inherit" }}>
                    <span className="app-card" style={{ minHeight: 0, padding: 0, boxShadow: "none" }}><span className="ico" style={{ background: s.status === "live" ? "var(--brand)" : "#5E6A78" }}><Icon name={domain.icon} size={14} /></span></span>
                    <span style={{ flex: 1 }}>{s.name}</span>
                    <span className={`status ${s.status === "live" ? "info" : ""}`}>{STATUS_LABEL[s.status]}</span>
                  </Link>
                ))}
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}
